import { render, staticRenderFns } from "./agv-rating.vue?vue&type=template&id=2dd9778a&scoped=true&lang=pug&"
import script from "./agv-rating.vue?vue&type=script&lang=js&"
export * from "./agv-rating.vue?vue&type=script&lang=js&"
import style0 from "./agv-rating.vue?vue&type=style&index=0&id=2dd9778a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd9778a",
  null
  
)

export default component.exports